import React, { useEffect, useState } from "react";
import { Button, Tooltip } from "antd";
import Organizer from "components/organizer";
import Icons from "components/icons";
import { Localize } from "components/service";
import { usePermissionByObject } from "components/permissions";
import { emailChannelUseMutation } from "../hooks";
import type { TEmailChannel } from "../helpers/email-channel-types-helper";

interface IEmailChannelVisibilityFieldProps {
  channel: TEmailChannel;
  variables: Record<string, any>;
}

const EmailChannelVisibilityField: React.FC<
  IEmailChannelVisibilityFieldProps
> = ({ channel, variables }) => {
  const [visible, setVisible] = useState(channel.is_visible === true);
  const { hasPermission } = usePermissionByObject(Organizer.Const.permissions.UPDATE);
  const {
    _setEmailChannelCreateUpdate,
    loadingMutationEmailChannelCreateUpdate,
  } = emailChannelUseMutation.createUpdate(channel.id, variables);

  useEffect(() => setVisible(channel.is_visible === true), [channel.is_visible]);

  const handleChange = async () => {
    const nextVisible = !visible;
    setVisible(nextVisible);
    try {
      await _setEmailChannelCreateUpdate({
        variables: {
          input: {
            id: channel.id,
            exhibition_type_id: channel.exhibition_type_id,
            is_active: channel.is_active === true,
            is_visible: nextVisible,
          },
        },
      });
    } catch (_) {
      setVisible(!nextVisible);
    }
  };

  return (
    <Tooltip
      overlayClassName="email-channel-tooltip"
      placement="bottom"
      title={
        visible
          ? <Localize>EMAIL_CHANNEL.Tooltip_Hide</Localize>
          : <Localize>EMAIL_CHANNEL.Tooltip_Show</Localize>
      }
    >
      <Button
        type="text"
        size="small"
        className={`email-channel-visibility-control ${
          visible ? "is-visible" : "is-hidden"
        }`}
        disabled={!hasPermission || loadingMutationEmailChannelCreateUpdate}
        onClick={handleChange}
      >
        {visible ? <Icons.Visible /> : <Icons.Hidden />}
        <Localize>
          {visible
            ? "EMAIL_CHANNEL.Visibility_Visible"
            : "EMAIL_CHANNEL.Visibility_Hidden"}
        </Localize>
      </Button>
    </Tooltip>
  );
};

export default EmailChannelVisibilityField;
